var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgImpression(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8021_79723)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 7.99992,
    cy: 8.49992,
    r: 6.66667,
    fill: "#78909C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.3334 7.83325C10.8867 7.83325 11.3334 7.38659 11.3334 6.83325C11.3334 6.27992 10.8867 5.83325 10.3334 5.83325C9.78008 5.83325 9.33341 6.27992 9.33341 6.83325C9.33341 7.38659 9.78008 7.83325 10.3334 7.83325ZM5.66675 7.83325C6.22008 7.83325 6.66675 7.38659 6.66675 6.83325C6.66675 6.27992 6.22008 5.83325 5.66675 5.83325C5.11341 5.83325 4.66675 6.27992 4.66675 6.83325C4.66675 7.38659 5.11341 7.83325 5.66675 7.83325ZM8.00008 12.1666C9.35341 12.1666 10.5334 11.4266 11.1667 10.3333C11.2934 10.1133 11.1334 9.83325 10.8734 9.83325H5.12675C4.87341 9.83325 4.70675 10.1133 4.83341 10.3333C5.46675 11.4266 6.64675 12.1666 8.00008 12.1666Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8021_79723"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImpression);
export default __webpack_public_path__ + "static/media/impression.01844faf9bbd8f15da5d7b42395c7b5c.svg";
export { ForwardRef as ReactComponent };